import { Component, OnInit } from "@angular/core";
import { Navigation } from "@angular/router";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { PDFDocument } from "pdf-lib";
import { DomSanitizer } from "@angular/platform-browser";
import { DatePipe } from "@angular/common";
import { AppComponent } from "src/app/app.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavigationExtras, Router } from "@angular/router";
import { CurrencyPipe } from "@angular/common";
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es";

registerLocaleData(localeEs);

type OddFields = 2 | 3

@Component({
  selector: "app-contract-details",
  templateUrl: "./contract-details.component.html",
  styleUrls: ["./contract-details.component.scss"],
})
export class ContractDetailsComponent implements OnInit {
  contractId: any;
  fileUrl: any;

  pdfSrc = "assets/contrato-cc.pdf?v=3";
  hasMultiplePolicies = false;
  multipdfSrc = "assets/contrato-cc-multi.pdf?v=4";
  enMultipdfSrc = "assets/contrato-cc-multi-en.pdf?v=4";
  enpdfSrc = "assets/contrato-cc-en.pdf?v=4";
  
  pdfBytes: Uint8Array;
  contractDetails: any;
  fullContractDetails: any;
  pdfView: Uint8Array;
  fileName: string;
  automaticDebitStatus = false;
  public contractForm: FormGroup;
  accountTypeStatus: any;
  role: any = localStorage.getItem("producerId") ? "producer" : "";
  installments: any;
  installmentEdit: any;
  installmentsCreated = false;
  notes: any;

  language = "es";
  activeLang: any;
  branches: any;

  loading: boolean = true;

  producer: any;

  selectedPolicy: any;

  constructor(
    private router: Router,
    private appComp: AppComponent,
    private authService: AuthenticationService,
    private sanitizer: DomSanitizer,
    private _fb: FormBuilder
  ) {
    const nav: Navigation | null = this.router.getCurrentNavigation();
    try {
      if (nav && nav.extras.state!["contract"]) {
        this.contractDetails = nav.extras.state!["contract"];
        this.contractDetails.active = true;
      } else {
        this.router.navigate(["/contracts"]);
        return;
      }
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
      this.router.navigate(["/contracts"]);
    }
  }

  updateLanguage(event: any) {
    let val = event.target.value;
    console.log(val);
    this.activeLang = val;
    if (val == "en") {
      if (this.contractDetails.multiplePolicies) {
        this.pdfSrc = "assets/multi-policy-contract-en.pdf?v=4";
      } else {
        this.pdfSrc = "assets/contract-en.pdf?v=4";
      }
      this.contractRefresh();
    } else {
      if (this.contractDetails.multiplePolicies) {
        this.pdfSrc = "assets/multi-policy-contract.pdf";
      } else {
        this.pdfSrc = "assets/contrato-cc.pdf?v=5";
      }
      this.contractRefresh();
    }
  }

  async ngOnInit(): Promise<void> {
    // this.contractDetails = {
    //   id: 0,
    //   active: 1,
    //   insCellphone: "",
    //   insOtherphone: "",
    //   insName: "",
    //   insEmail: "",
    //   physicalAddress1: "",
    //   physicalAddress2: "",
    //   physicalCity: "",
    //   physicalState: "",
    //   physicalZip: "",
    //   postalAddress1: "",
    //   postalAddress2: "",
    //   postalCity: "",
    //   postalState: "",
    //   postalZip: "",
    //   branchName: "",
    //   branchAddress: "",
    //   producerName: "",
    //   producerPhone: "",
    // }

    // let contract:any = this.authService.getContract2();
    // console.log('🔥📣 contract', contract, '🔥📣');
    // this.contractDetails = JSON.parse(contract);

    const response = (await this.authService.getContractDetails(
      this.contractDetails.id
    )) as any;
    this.fullContractDetails = response && response[0] ? response[0] : response;
    console.log(
      "✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅ this.fullContractDetails",
      this.fullContractDetails,
      "✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅✅"
    );

    this.contractId = this.contractDetails.contractName;
    this.hasMultiplePolicies = this.fullContractDetails.policies && this.fullContractDetails.policies.length > 1
    try {
      const response = (await this.authService.getProducers()) as any[];
      if (response && response.length) {
        const producersArray =
          response[0] && response[0].length ? response[0] : response;
        const producer = producersArray.find(
          (p: any) => p.id === this.contractDetails.producerId
        );
        if (producer) this.producer = producer;
      }
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
      this.loading = false;
    }
    const contractDetails = {
      ...this.contractDetails,
      ...this.fullContractDetails,
    };
    this.createPDFContract(contractDetails);
    this.installmentsCreated = false;
    // this.role = this.authService.getUserRole();
    // this.appComp.loading = true;
    // this.contractId = this.route.snapshot.paramMap.get("id");

    this.contractForm = this._fb.group({
      showAnualInterest: [null, [Validators.required]],
      textMsgNotification: [null, [Validators.required]],
      automaticDebit: [null, [Validators.required]],
      bankInstName: [""],
      bankInstRoutingNum: [""],
      accountNumber: [""],
      accountType: [""],
      cardType: [""],
      cardNumber: [""],
      cardExp: [""],
    });
    //  this.authService.getContract(this.contractId).then(res=>{
    //   this.contractDetails = res;
    //   this.notes = this.contractDetails.notes;
    //   this.installments = this.contractDetails.contractInstallments;
    //   if(this.contractDetails.contractInstallments.length > 1){
    //     this.installmentsCreated = true;
    //   }
    //   console.log(this.contractDetails);
    //   if(this.contractDetails.multiplePolicies){
    //     this.pdfSrc = 'assets/multi-policy-contract.pdf';
    //   } else {
    //     this.pdfSrc = 'assets/contract.pdf';
    //   }
    //   this.authService.getBranches({id:this.contractDetails.idCompany}).then(res2=>{
    //     this.branches = res2;
    //     this.createPDFContract(res);
    //   },err=>{});

    //   // console.log(res);
    //   let saveData = this.authService.getFinaceData(this.contractDetails.id);
    //   if(saveData){
    //     this.contractForm.patchValue(saveData);
    //     this.updateAutomaticDebit();
    //     this.updateAccountType();
    //     // this.contractRefresh();
    //   }
    //   this.appComp.loading = false;

    //  },err=>{
    //   console.log(err);
    //   this.appComp.loading = false;
    //  })
    this.loading = false;
  }

  getContractDetails() {
    this.authService.getContract(this.contractId).then(
      (res) => {
        this.contractDetails = res;
        this.installments = this.contractDetails.contractInstallments;
        console.log(this.contractDetails.contractInstallments.length);
        if (this.contractDetails.contractInstallments.length > 1) {
          this.installmentsCreated = true;
        }
        const contractDetails = {
          ...this.contractDetails,
          ...this.fullContractDetails,
        };
        this.createPDFContract(contractDetails);
        // console.log(res);
        this.appComp.loading = false;
      },
      (err) => {
        console.log(err);
        this.appComp.loading = false;
      }
    );
  }

  updateAutomaticDebit() {
    let autoDebit = this.contractForm.controls["automaticDebit"].value;
    this.automaticDebitStatus = autoDebit == "si" ? true : false;
  }

  updateAccountType() {
    this.accountTypeStatus = this.contractForm.controls["accountType"].value;
    if (
      this.accountTypeStatus == "cheque" ||
      this.accountTypeStatus == "ahorro"
    ) {
      this.contractForm.patchValue({
        cardNumber: "",
        cardType: "",
        cardExp: "",
      });
    } else if (this.accountTypeStatus == "credito") {
      this.contractForm.patchValue({
        accountNumber: "",
        bankInstRoutingNum: "",
      });
    }
  }

  downloaded() {
    if (
      this.contractDetails &&
      this.contractDetails.contractInstallments &&
      this.contractDetails.contractInstallments.length <= 0
    ) {
      this.generatePayments();
    }
    if (this.role == "producer") {
      this.contractDetails.downloaded = 1;
      this.appComp.loading = true;
      this.authService.updateContract(this.contractDetails).then(
        (res) => {
          console.log(res);
          this.appComp.loading = false;
          this.getContractDetails();
        },
        (err) => {
          console.log(err);
          this.appComp.loading = false;
        }
      );
    }
    this.authService.removeFinaceData(this.contractDetails.id);
  }

  contractRefresh() {
    let showAnnualPercent =
      this.contractForm.controls["showAnualInterest"].value;
    console.log(this.contractDetails);
    let contractDetails2 = structuredClone(this.contractDetails);
    if (showAnnualPercent == "no") {
      contractDetails2.qAnnualPercent = "";
    }
    let contractDetails = {
      ...contractDetails2,
      ...this.contractForm.getRawValue(),
    };
    let data = {
      id: this.contractDetails.id,
      data: this.contractForm.getRawValue(),
    };
    console.log(
      "🔥📣 this.contractForm",
      this.contractForm.getRawValue(),
      "🔥📣"
    );
    this.authService.saveFinanceData(data);
    this.createPDFContract(contractDetails);
  }

  editContract() {
    let navigationExtras: NavigationExtras = {
      state: {
        quoteData: this.contractDetails,
      },
    };
    this.router.navigate(["/quotation"], navigationExtras);
  }

  async createPDFContract(data: any) {
    if (!data) return;
    const sucAgency = this.authService.getSucAgency();
    const isVirginIsland = sucAgency == "76";

    if (this.hasMultiplePolicies) {
      this.pdfSrc = isVirginIsland ? this.enMultipdfSrc : this.multipdfSrc;
    } else this.pdfSrc = isVirginIsland ? this.enpdfSrc : this.pdfSrc;
    let pdfSrc = this.pdfSrc;
    let datePipe = new DatePipe("en-US");
    const currencyPipe = new CurrencyPipe("en-US");
    let existingPDFBytes = await fetch(pdfSrc).then((res) =>
      res.arrayBuffer()
    );
    var bytes = new Uint8Array(existingPDFBytes);
    const pdfDoc = await PDFDocument.load(existingPDFBytes);
    const form = pdfDoc.getForm();
    // ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️ WIP ⬇️
    // Get all the fields in the form
    const fields = form.getFields();
    // if (this.producer)
    //   form.getTextField("producerName").setText(this.producer.complete_name);
    // Extract the field names
    const fieldNames = fields.map((field) => field.getName());
    let expDate1 = data.expirationDate
    form.getTextField("contractName").setText(data.contractName);
    // form.getTextField("contractId").setText('# ' + data.id.toString());
    const totalPayments = currencyPipe.transform(
      data.totalPayments,
      "USD",
      "symbol",
      "1.2-2"
    );
    form.getTextField("totalPayments").setText(totalPayments || " ");
    // form.getTextField('id').setText(data.id.toString());
    // form.getTextField('insCellphone').setText(data.insCellphone);
    // form.getTextField("Fecha").setText(this.formatDate(data.formalizationDate));

    form.getTextField("agencyName").setText(data.agencyName);
    // form.getTextField('policyName').setText(data.contractName);
    // form.getTextField('insOtherphone').setText(data.insOtherphone ?? '');
    try {
      if (data.bankInstRoutingNum)
        form
          .getTextField("bankInstRoutingNum")
          .setText(data.bankInstRoutingNum);
      if (data.bankInstName)
        form.getTextField("bankInstName").setText(data.bankInstName);
      if (data.accountNumber)
        form.getTextField("accountNumber").setText(data.accountNumber);
      if (data.accountType)
        form
          .getTextField("accountTypeAhorro")
          .setText(data.accountType === "ahorro" ? "X" : "");
      if (data.accountType)
        form
          .getTextField("accountTypeCheque")
          .setText(data.accountType === "cheque" ? "X" : "");
      if (data.accountType)
        form
          .getTextField("accountTypeCredit")
          .setText(data.accountType === "credito" ? "X" : "");
      if (data.cardType)
        form
          .getTextField("cardTypeV")
          .setText(data.cardType === "Visa" ? "X" : "");
      if (data.cardType)
        form
          .getTextField("cardTypeM")
          .setText(data.cardType === "Master Card" ? "X" : "");
      if (data.cardType)
        form
          .getTextField("cardTypeA")
          .setText(data.cardType === "American Express" ? "X" : "");
      if (data.cardNumber)
        form.getTextField("cardNumber").setText(data.cardNumber);
      if (data.cardExp)
        form.getTextField("cardExp1").setText(data.cardExp.split("/")[0]);
      if (data.cardExp)
        form.getTextField("cardExp2").setText(data.cardExp.split("/")[1]);
      if (data.bankInstRoutingNum)
        form
          .getTextField("bankInstRoutingNum")
          .setText(data.bankInstRoutingNum);

  // HERE SETTING SIGNATURE
  try {
    const signatureBytes = await fetch(`assets/firmas/${data.producerId}.png`).then(res => res.arrayBuffer());;


    // Embed as a PDFImage
    const signatureImage = await pdfDoc.embedPng(signatureBytes);

    // Access the button field
    const sigButton = form.getButton("signature_af_image");

    // Place the image into it
    sigButton.setImage(signatureImage);
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
      const signatureBytes = await fetch('assets/firmas/empty.png').then(res => res.arrayBuffer());
      // Embed as a PDFImage
      const signatureImage = await pdfDoc.embedPng(signatureBytes);

      // Access the button field
      const sigButton = form.getButton("signature_af_image");

      // Place the image into it
      sigButton.setImage(signatureImage);
    }

  try {
    // Firma de la representante del financiador que nunca va a cambiar
    const signatureBytes = await fetch("assets/firmas/firma-example.png").then(res => res.arrayBuffer());

    // Embed as a PDFImage
    const signatureImage = await pdfDoc.embedPng(signatureBytes);

    // Access the button field
    const firmaBtn = form.getButton('firma_af_image'); 

    // Place the image into it
    firmaBtn.setImage(signatureImage);
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
    }

    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
    }
    try {
      form.getTextField("custMobile").setText(data.custMobile);
      form.getTextField("custMobile").setText(data.custMobile);
      form.getTextField("custPhone").setText(data.custPhone);
      form.getTextField("producerName").setText(data.producerName);
      form.getTextField("producerId").setText(`${data.producerId}`);
      form.getTextField("fullAddress").setText(data.fullAddress.replaceAll(',', ''));

      const downPaymentOne = currencyPipe.transform(
        (data.policies[0].downPayment),
        "USD",
        "symbol",
        "1.2-2"
      );
      form.getTextField("downPaymentOne").setText(downPaymentOne || " ");
      const downPayment = currencyPipe.transform(
        (data.downPayment),
        "USD",
        "symbol",
        "1.2-2"
      );
      form.getTextField("downPayment").setText(downPayment || " ");

      const aFinanciar = currencyPipe.transform(
        data.policies[0].premium  - data.policies[0].downPayment,
        "USD",
        "symbol",
        "1.2-2"
      );
      const cantidadFinanciar = currencyPipe.transform(
        (data.aFinanciar),
        "USD",
        "symbol",
        "1.2-2"
      );
      form.getTextField("aFinanciarOne")?.setText(aFinanciar || " ");
      form.getTextField("cantidadFinanciar").setText(cantidadFinanciar || " ");

      try {
        form.getTextField("compania").setText(data.policies[0].companyName || " ");
      } catch (error) {
        console.log('🚨 ERROR', error, '🚨');
      }
      const monthlyPayment = currencyPipe.transform(
        data.monthlyPayment,
        "USD",
        "symbol",
        "1.2-2"
      );
      form.getTextField("monthlyPayment").setText(monthlyPayment || " ");
      form.getTextField("monthlyPayment2").setText(monthlyPayment || " ");

      form.getTextField("apr").setText(`${data.apr}%`);
      form.getTextField("custPhone").setText(data.custPhone);
      form.getTextField("customerName").setText(data.customerName);
      form.getTextField("months").setText(`${data.months}`);
      form.getTextField("months2").setText(`${data.months}`);
      form.getTextField("custEmail").setText((data.custEmail || ' '));

      const premium = currencyPipe.transform(
        (data.policies[0].premium),
        "USD",
        "symbol",
        "1.2-2"
      );
      form.getTextField("prima").setText(premium || " ");

      const totalSalePrice = currencyPipe.transform(
        data.totalSalePrice,
        "USD",
        "symbol",
        "1.2-2"
      );
      const totalSalePrice2 = currencyPipe.transform(
        data.totalSalePrice - data.downPayment,
        "USD",
        "symbol",
        "1.2-2"
      );
      form.getTextField("totalPrice").setText(totalSalePrice || " ");
      form.getTextField("totalSalePrice2").setText(totalSalePrice2 || " ");

      let selectedPolicy = this.selectedPolicy

      if (!selectedPolicy) {
        selectedPolicy = data.policies[0];
      }



      form.getTextField("policy").setText(data.custPolicy);
      let datePipe = new DatePipe("en-US");
      const datePipeEs = new DatePipe("es-MX");
      if (typeof data.effectiveDate === "string") {
        const effectiveDate = datePipe.transform(
          data.effectiveDate,
          "MM/dd/yyyy"
        );
        if (effectiveDate)
          form.getTextField("effectiveDate").setText(effectiveDate);
        const firstPayMonthName = isVirginIsland
          ? datePipe.transform(data.effectiveDate, "MMMM") ?? " "
          : datePipeEs.transform(data.effectiveDate, "MMMM") ?? " ";
        form.getTextField("firstPayMonth").setText(firstPayMonthName);
      }

      if (typeof data.expirationDate === "string") {
        try {
          expDate1 = this.addMonthsClamped(data.formalizationDate, data.months);
        } catch (error) {
          expDate1 = data.expirationDate
        }
        const expirationDate = datePipe.transform(
          expDate1,
          "MM/dd/yyyy"
        );
        if (expirationDate) {
          const expirationDate = datePipe.transform(
          data.expirationDate,
          "MM/dd/yyyy"
        );
          form.getTextField("expirationDate").setText(expirationDate || '');
        }
        const expDate = new Date(expDate1);
        form.getTextField("lastPayDay").setText(expDate.getDate().toString());

        const lastPayMonthName = isVirginIsland
          ? datePipe.transform(expDate1, "MMMM") ?? " "
          : datePipeEs.transform(expDate1, "MMMM") ?? " ";
        form.getTextField("lastPayMonth").setText(lastPayMonthName);

        form
          .getTextField("lastPayYear")
          .setText(expDate.getFullYear().toString());
      }
      if (typeof data.formalizationDate === "string") {
        const formalizationDate = datePipe.transform(
          data.formalizationDate,
          "MM/dd/yyyy"
        );
        if (formalizationDate)
          form.getTextField("formalizationDate").setText(formalizationDate);
        const date = new Date(data.formalizationDate);
        form.getTextField("firstPayDay").setText((date.getDate()).toString());
        form.getTextField("firstPayDay2").setText((date.getDate()).toString());
        const firstPayMonthName2 = isVirginIsland
          ? datePipe.transform(data.formalizationDate, "MMMM") ?? " "
          : datePipeEs.transform(data.formalizationDate, "MMMM") ?? " ";
        form.getTextField("firstPayMonth").setText(firstPayMonthName2);
        form
          .getTextField("yearfirstPay")
          .setText(date.getFullYear().toString());
      }
      // form.getTextField("nombreCompania").setText(data.nombreCompania);
      if (data.invoiceNumber)
        form.getTextField("invoiceNumber").setText(data.invoiceNumber);
      form
        .getTextField("cargoPorFinanciamiento")
        .setText(
          currencyPipe.transform(
            data.cargoPorFinanciamiento,
            "USD",
            "symbol",
            "1.2-2"
          ) || " "
        );
    } catch (error) {
      console.log("🚨 ERROR", error, "🚨");
    }

    if (this.hasMultiplePolicies) {
      try {
        form.getTextField("policy-2").setText((data.policies[1].prefix + '-' + data.policies[1].policyNumber).toString());
        const premium = currencyPipe.transform(
          data.policies[1].premium,
          "USD",
          "symbol",
          "1.2-2"
        ) || data.policies[1].premium;
        const downPayment = currencyPipe.transform(
          data.policies[1].downPayment,
          "USD",
          "symbol",
          "1.2-2"
        ) || data.policies[1].downPayment;
        const aFinanciar = currencyPipe.transform(
          data.policies[1].premium  - data.policies[1].downPayment,
          "USD",
          "symbol",
          "1.2-2"
        ) || (data.policies[1].premium - data.policies[1].downPayment).toString();
        form.getTextField("premium-2").setText(premium);
        form.getTextField('toFinance').setText(aFinanciar)
        form.getTextField("companyDos").setText(data.policies[1].companyName || '')
        form.getTextField("downPayment-2").setText(downPayment);
      } catch (error) {
        console.log('🚨 ERROR', error, '🚨');
      }

      if (this.fullContractDetails.policies.length > 2) {
        let premiumTotal = 0
        let downPaymentTotal = 0
        let aFinanciarTotal = 0
        for (let index = 0; index < this.fullContractDetails.policies.length; index++) {
          const policy = this.fullContractDetails.policies[index];
          form.getTextField(`policy${index}`).setText((policy.prefix + '-' + policy.policyNumber).toString());
          
          premiumTotal += policy.premium;
          const premium = currencyPipe.transform(
            policy.premium,
            "USD",
            "symbol",
            "1.2-2"
          ) || policy.premium;
          downPaymentTotal += policy.downPayment;
          const downPayment = currencyPipe.transform(
            policy.downPayment,
            "USD",
            "symbol",
            "1.2-2"
          ) || policy.downPayment;
          const effectiveDate = datePipe.transform(
            policy.effectiveDate || data.effectiveDate,
            "MM/dd/yyyy"
          );
          const expirationDate = datePipe.transform(
              data.expirationDate,
              "MM/dd/yyyy"
          );
          const aFinanciar = currencyPipe.transform(
          policy.premium - policy.downPayment,
            "USD",
            "symbol",
            "1.2-2"
          ) || (policy.premium - policy.downPayment).toString();
          const oddOnes = [2, 3].includes(index)
          // Hay un problema misterioso donde hay fields que no se formatean bien a la derecha. 
          // a esos campos los manejamos así para que se vean como queremos
          // sé que no es lindo pero hay que hacerlo funcionar. Esos son los campos 2 y tres
          // y los tuve que hacer campos "2" y "3" y los tuve que cambiar a Dos y a Tres para que
          // se alinearan a la derecha.
          const numberDict = {
            2: 'Dos',
            3: 'Tres'
          }
          form.getTextField(`premium${oddOnes ? numberDict[index as OddFields] : index}`).setText(premium);
          form.getTextField(`downPayment${oddOnes ? numberDict[index as OddFields] : index}`).setText(downPayment);
          if (effectiveDate)
            form.getTextField(`effectiveDate${index}`).setText(effectiveDate);
          if (expirationDate)
            form.getTextField(`expirationDate${index}`).setText(expirationDate);
          aFinanciarTotal += (policy.premium - policy.downPayment);
          if (aFinanciar)
            form.getTextField(`aFinanciar${oddOnes ? numberDict[index as OddFields] : index}`).setText(aFinanciar);
          try {
            if (aFinanciar)
            form.getTextField(`company${index}`).setText(policy.companyName);
          } catch (error) {
            
          }
        }
        const premiumTotalString = currencyPipe.transform(
            premiumTotal,
            "USD",
            "symbol",
            "1.2-2"
          ) || premiumTotal.toString();
        form.getTextField('premiumTotal').setText(premiumTotalString);
        const downPaymentTotalString = currencyPipe.transform(
            downPaymentTotal,
            "USD",
            "symbol",
            "1.2-2"
          ) || downPaymentTotal.toString();
        form.getTextField('downPaymentTotalCol').setText(downPaymentTotalString);
        const aFinanciarTotalString = currencyPipe.transform(
            aFinanciarTotal,
            "USD",
            "symbol",
            "1.2-2"
          ) || aFinanciarTotal.toString();
        form.getTextField('aFinanciarTotal').setText(aFinanciarTotalString);
      } else if (this.fullContractDetails.policies.length === 2) {
      const lastIndex = pdfDoc.getPageCount() - 1;

      if (lastIndex >= 0) {
        pdfDoc.removePage(lastIndex);
      }

      await pdfDoc.save();
    }
    }

    let formatted: any;
    try {
      const date = new Date(data.formalizationDate);
      formatted = date.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    } catch (error) {}
    this.fileName = `contrato-Central-Credit-${data.agencyName}-${
      data.customerName
    }${formatted ? "-" + formatted : ""}`;

    form.flatten();
    this.pdfBytes = await pdfDoc.save();

    const blob = new Blob([this.pdfBytes as any], { type: "application/pdf" });

    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.pdfView = new Uint8Array(fileReader.result as ArrayBuffer);
    };
    fileReader.readAsArrayBuffer(blob);
  }


  markPaid(installment: any) {
    console.log(installment);
    this.installmentEdit = installment;
    this.installmentEdit.details = true;
  }

  updateNotes() {
    this.appComp.loading = true;
    this.contractDetails.notes = this.notes;
    this.authService.updateContract(this.contractDetails).then(
      (res) => {
        console.log(res);
        this.appComp.loading = false;
      },
      (err) => {
        console.log(err);
        this.appComp.loading = false;
      }
    );
  }

  generatePayments() {
    let data = {
      id: this.contractDetails.id,
      Installments: this.contractDetails.qInstallments,
      Amount: this.contractDetails.qInstallmentAmount,
      InstallmentDate: this.contractDetails.dateFirstpay,
      quarterlyPayments: this.contractDetails.quarterlyPayments,
    };
    console.log(data);
    this.authService.createInstallments(data).then(
      (res) => {
        this.getContractDetails();
        console.log(res);
      },
      (err) => {
        console.log(err);
      }
    );
  }

  formatDate(isoString: string): string {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  addMonthsClamped(dateInput: Date | string, months: number): Date {
    const d = new Date(dateInput);
    const day = d.getDate();
    d.setMonth(d.getMonth() + Number(months) - 1);
    if (d.getDate() < day) d.setDate(0); // clamp to last day of target month
    return d;
  }

}
